import Api from '../../services/api';
import {
  FETCH_TICKETS,
  FETCH_TICKETS_FAILURE,
  FETCH_TICKETS_SUCCESS,
  SET_PASSENGERS_COUNTS,
  SET_TICKETS_INFO,
} from './constants';

export const fetchTickets = (ticketType, connectionId1, connectionId2) => ({
  type: FETCH_TICKETS,
  payload: {
    ticketType,
    connectionId1,
    connectionId2,
  },
});

export const fetchTicketsFailure = (
  ticketType,
  connectionId1,
  connectionId2,
) => ({
  type: FETCH_TICKETS_FAILURE,
  payload: {
    ticketType,
    connectionId1,
    connectionId2,
  },
});

export const fetchTicketsSuccess = (
  tickets,
  ticketType,
  connectionId1,
  connectionId2,
) => ({
  type: FETCH_TICKETS_SUCCESS,
  payload: {
    tickets,
    ticketType,
    connectionId1,
    connectionId2,
  },
});

export const loadTickets = (
  ticketType,
  connectionId1,
  connectionId2 = undefined,
) => {
  return async dispatch => {
    dispatch(fetchTickets(ticketType, connectionId1, connectionId2));
    try {
      const response = await Api.getTickets(
        ticketType,
        connectionId1,
        connectionId2,
      );
      dispatch(
        fetchTicketsSuccess(
          response.tickets,
          ticketType,
          connectionId1,
          connectionId2,
        ),
      );
    } catch (e) {
      dispatch(fetchTicketsFailure(ticketType, connectionId1, connectionId2));
      throw e;
    }
  };
};

export const setCounts = counts => ({
  type: SET_PASSENGERS_COUNTS,
  payload: counts,
});

export const setTicketsInfo = ticketsInfo => ({
  type: SET_TICKETS_INFO,
  payload: ticketsInfo,
});



// WEBPACK FOOTER //
// ./src/containers/Passengers/actions.js